import APIClient from '@/shared/http/clients/api'
import APIClientUpload from '../../clients/apiupload'

const resourceName = 'reforco'
// const APICore = process.env.APIBaseURLCore
const APIBusiness = process.env.APIBaseURLBusinessCommon

const PostReforco = (funcionarioId, data, config = {}) => APIClientUpload.post(`${APIBusiness}/${resourceName}/PostReforco/${funcionarioId}`, data, config)
const AlteraValorReforco = (reforcoId, funcionarioId, data = {}, config = {}) => APIClient.put(`${APIBusiness}/${resourceName}/AlteraValorReforco/${reforcoId}/${funcionarioId}`, data, config)
const ExclusaoReforco = (reforcoId, empresaid, config = {}) => APIClient.put(`${APIBusiness}/${resourceName}/ExlusaoReforco/${reforcoId}/${empresaid}`, config)
const GetReforcoById = (funcionarioId, empresaid, limit, index, config = {}) => APIClient.get(`${APIBusiness}/${resourceName}/GetReforcoById/${funcionarioId}/${empresaid}?limit=${limit}&index=${index}`, config)
const GetAnexoReforcoById = (reforcoId, data = {}, config = {}) => APIClient.get(`${APIBusiness}/${resourceName}/GetAnexoReforcoid/${reforcoId}`, data, config)
const PosDonwload = (arquivoId, companyid, data = {}, config = {}) => APIClient.get(`${APIBusiness}/${resourceName}/DownloadReforcoConprovante/${arquivoId}/${companyid}`, data, config)

const ReinforcementRepository = {
  PosDonwload,
  GetReforcoById,
  GetAnexoReforcoById,
  PostReforco,
  AlteraValorReforco,
  ExclusaoReforco
}

export default ReinforcementRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/reinforcement.js